import React from 'react';

export interface Preset {
  label: string;
  alias: string;
}

interface AdminFormHeaderProps {
  title: string;
  subtitle: string;
  presets?: Preset[];
  activePreset?: string;
  canChangePreset?: boolean,
  onPresetChange?: (alias: string) => void;
  onPreviewClick?: () => void;
}

const AdminFormHeader: React.FC<AdminFormHeaderProps> = ({
  title,
  subtitle,
  presets = [],
  activePreset,
  canChangePreset = true,
  onPresetChange,
  onPreviewClick
}) => {
  const handlePresetClick = (alias: string) => {
    if (onPresetChange) {
      onPresetChange(alias);
    }
  };

  return (
    <div id="page-header" className="mb-8">
      <h1 className="text-3xl font-cinzel font-bold text-gray-900">
        <span>{title}</span>
        {onPreviewClick && (
          <button
            onClick={onPreviewClick}
            className="ml-4 text-gray-600 hover:text-gray-900 transition-colors align-middle"
            title="Preview"
          >
            <i className="fa fa-up-right-from-square text-lg mb-2"></i>
          </button>
        )}
        {presets.length > 0 && (
          <small className="font-light text-gray-600">
            <i className="ml-8 fa fa-angles-right"/>
            {presets.map((preset, index) => (
              <React.Fragment key={preset.alias}>
                <span
                  className={`ml-4 cursor-pointer hover:text-gray-800
                    ${activePreset === preset.alias ? 'font-semibold text-gray-800' : ''}
                    ${canChangePreset ? '' : 'cursor-default'}`}
                  onClick={() => handlePresetClick(preset.alias)}
                >
                  {preset.label}
                </span>
                {index < presets.length - 1 && <i className="ml-4">•</i>}
              </React.Fragment>
            ))}
          </small>
        )}
      </h1>
      <p className="text-gray-600 mt-2">{subtitle}</p>
    </div>
  );
};

export default AdminFormHeader;
